import { createContext, ReactNode, useEffect, useState } from "react";
import constants from "src/constants";
import getCookieByName from "src/functions/getCookieByName";
import validateAuthToken from "src/functions/validateAuthToken";

export interface UserContextInterface {
  user: {
    id: number;
    email: string;
    role: {
      id: number;
    };
  };
  client: {
    userId: string;
    id: number;
    name: string;
    surname: string;
    phone: string;
    subs_trial_till: string;
    subscription_till: string;
    subscription: {
      id: number;
    };
    address: {
      street: string;
      city: string;
      zip: string;
      country: string;
    };
    profile: {
      id: string;
    };
    card_no: string;
    subscription_renew: boolean;
  };
}

export const UserContext = createContext<UserContextInterface>({
  user: {
    id: 0,
    email: "",
    role: {
      id: 0,
    },
  },
  client: {
    userId: "",
    id: 0,
    name: "",
    surname: "",
    phone: "",
    subscription_till: "",
    subs_trial_till: "",
    subscription: {
      id: 0,
    },
    address: {
      street: "",
      city: "",
      zip: "",
      country: "",
    },
    profile: {
      id: "",
    },
    card_no: "",
    subscription_renew: false,
  },
});

type Props = {
  children: ReactNode;
};

export function UserContextProvider({ children }: Props) {
  const isAuthorized = getCookieByName(`auth-token`);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchUser = () => {
      typeof isAuthorized === "string"
        ? fetch(`${constants.Paths.apiUrl}/users/me`, {
            headers: validateAuthToken(getCookieByName(`auth-token`)),
          })
            .then((response) => response.json())
            .then((userData) => {
              fetch(`${constants.Paths.apiUrl}/clients/me`, {
                method: "GET",
                headers: validateAuthToken(getCookieByName(`auth-token`)),
              })
                .then((response) => response.json())
                .then((clientData) =>
                  setData({ user: userData, client: clientData })
                );
            })
        : setData(false);
    };

    fetchUser();
  }, [isAuthorized]);

  return <UserContext.Provider value={data}>{children}</UserContext.Provider>;
}
